export default "__VITE_ASSET__CUEmTpUM__"